import { Department, DepartmentControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
export const useEditDepartMent = () =>
  useMutationWithLoading(async (params: Department & { xTENANTID?: string }) =>
    new DepartmentControllerApi(getConfigObject()).updateDepartment(
      params,
      params.xTENANTID
    )
  );
